import { computed, ComputedRef, Ref, unref } from 'vue';
import { CODES, useLiveQueryV2 } from '@libs/use';
import type { OrderItem } from '@libs/api-reference';
import {
  SYMBOL_TRADE_CHANNEL_PREFIX,
  transformTradePriceChange,
} from '@core/symbol';

import { updateTradePrice } from '../utils/updateTradePrice';
import * as API from '../requests';
import { ORDERS_QUERY_KEYS } from '../constants';

export default function useLiveOrderQuery({
  orders,
  orderId,
}: {
  orders: ComputedRef<OrderItem[]>;
  orderId: Ref<string | undefined>;
}) {
  useLiveQueryV2<OrderItem>({
    fetcher: () => API.getOrder(unref(orderId) as string),
    immediate: computed(() => !!orderId.value),
    cacheTime: 10,
    staleTime: 10,
    key: ORDERS_QUERY_KEYS.order(orderId),
    getChannels: (result) => {
      return [
        `${SYMBOL_TRADE_CHANNEL_PREFIX}${unref(
          result?.data.instrumentIdentification
        )}`,
      ];
    },
    onSuccess(result) {
      const selectedOrderIndex = orders.value.findIndex(
        (s) => s.orderId === orderId?.value
      );

      if (selectedOrderIndex > -1) {
        Object.assign(orders.value[selectedOrderIndex], {
          lastTradePrice: result.data.lastTradePrice,
        });
      }
    },
    unsubscribe: false,
    onUpdate: function (signal) {
      const actions = {
        [CODES.SymbolTradePriceChangeSignal]: transformTradePriceChange,
      };

      if (actions[signal.code]) {
        const data: ReturnType<typeof transformTradePriceChange> = actions[
          signal.code
        ](signal.data);

        updateTradePrice(unref(orders), data);
      }
    },
  });
}
